import React from "react"
import { Redirect } from "react-router"
import { routePaths } from "../.."
import {
    APICollaborationModel,
    decodeCollaborationParams
} from "../../../Models/API/CollaboratorModel"
import { ProjectCollaborators } from "../../../Components/Views/Dashboard/Sections/AppDetail/Collaborators/Collaborators"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"

export type CollaboratorPaths = "list" | "invite"

export function AppCollaboratorsRoute({
    match,
    location
}: AppDetailRouteComponentProps) {
    const path = new URLSearchParams(location.search).get("path")
    const validPath = path === "list" || path === "invite" ? path : "list"
    const fallbackPath = routePaths.appCollaborators(
        match.params.orgUsername,
        match.params.appID,
        undefined,
        validPath
    )
    const filterAndSort = useDecodeFilterAndSort<APICollaborationModel>(
        location.search,
        { sortBy: "invitedEmail", desc: false },
        fallbackPath
    )
    const params = decodeCollaborationParams(filterAndSort)

    if (params.isError) {
        return <Redirect to={fallbackPath} />
    }

    return (
        <AppAuthCheck {...match.params} scope="collaborators:view">
            <ProjectCollaborators
                {...match.params}
                params={params.value}
                invite={validPath === "invite"}
                filterAndSort={filterAndSort}
            />
        </AppAuthCheck>
    )
}
